/* Global Variables */
var helper = require('../helpers/shoppayHelper');
var isBuyNow = window.shoppayClientRefs ? window.shoppayClientRefs.constants.isBuyNow : null;
var isAATest = window.shoppayClientRefs && window.shoppayClientRefs.preferences.shoppayAATest ? window.shoppayClientRefs.preferences.shoppayAATest : false;
var session;

$(document).ready(function () {
    if (window.ShopPay) {
        initShopPayConfig();
		if (window.shoppayClientRefs.preferences.shoppayEmailListenerEnabled && $('.shopify-email-listener').length) {
			initShopPayEmailRecognition();
		}
        var readyOnPageLoad = helper.isReadyToOrderOnPageLoad();
        if (readyOnPageLoad) {
			initShopPayButton();
            var pageLoadData = helper.getInitProductData();
            helper.setInitProductData(pageLoadData); // updates global prod data.
        }

        /*  The below code triggers if a product is a Buy Now item, but is not ready to order on page load
            (ex: required product attributes like color or size are not yet chosen). Here, a watcher is set
            to capture user interactions when product attributes are selected. Helper scripts will be triggered
            by these interactions to determine if the item is ready to order when all required attributes are
            selected.
        */
        if (isBuyNow && !readyOnPageLoad) {
            $(document).on('ProductDetailPage.Variant.Updated', initBuyNow); // receives the Event & Response
        } else {
            session = initShopPaySession();
        }
    }

	$(document).on('Cart.UpdateSuccess', function() {
		if (window.ShopPay && !isBuyNow) {
			if (!session) {
				session = initShopPaySession();
			} else {
				var paymentRequestResponse = helper.buildPaymentRequest(session);
				var responseJSON =  paymentRequestResponse ? paymentRequestResponse.responseJSON : null;
	
				if (responseJSON) {
					helper.shoppayBtnDisabledStyle(document.getElementById("shop-pay-button-container"));
				}
	
				if (responseJSON && !responseJSON.error && responseJSON.paymentRequest !== null) {
					session.close();
					session = initShopPaySession();
				}
			}
		}
	});
});

function initShopPayConfig() {
    window.ShopPay.PaymentRequest.configure({
        shopId: window.shoppayClientRefs.preferences.shoppayStoreId,
        clientId: window.shoppayClientRefs.preferences.shoppayClientId,
        debug: window.shoppayClientRefs.preferences.shoppayModalDebugEnabled
    });
}

function initShopPayButton() {
	var paymentSelectors = ['#shop-pay-button-container', '#shop-pay-button-container-mobile', '#shop-pay-button-container-desktop']
	for (var paymentSelectorIndex in paymentSelectors) {
		var paymentSelector = paymentSelectors[paymentSelectorIndex];
		if ($(paymentSelector).length > 0) {
			window.ShopPay.PaymentRequest.createButton({buyWith: isBuyNow}).render(paymentSelector);
			helper.shoppayMutationObserver(paymentSelector);
		}
	}
}


function initBuyNow(event) {
	if (!session) {
		session = initShopPaySession();
	}
	helper.setInitProductData({
		pid: $('input#pid').val(),
		quantity: 1
	});
	initShopPayButton();
}

function initShopPayEmailRecognition() {
    /*  If your checkout is not built with SFRA or you have customized and removed the 'email-guest'
        id on the email input you will need to update the id value for emailInputId

        Note: A 1.5 second delay has been added before attaching to the email trigger to the email field to
        accommodate users who may have incorporated browser autofills. The pop-up will appear if the field
        is autofilled with a recognized email address
    */
    setTimeout(function() {
		$('.shopify-email-listener:visible').each(function() {
			window.ShopPay.PaymentRequest.createLogin({emailInputId: $(this).attr('id')}).render('#shop-pay-login-container');
		});
    }, 1500);
}

$('body').on('cart:update product:afterAddToCart promotion:success', function () {
    /*  Only interested in cart updates on Cart page (cart updates are not triggered in checkout). Buy Now already
        has a separate event handler for changes to attribute selections
    */
    if (window.ShopPay && !isBuyNow) {
        if (!session) {
            session = initShopPaySession();
        } else {
            var paymentRequestResponse = helper.buildPaymentRequest(session);
            var responseJSON =  paymentRequestResponse ? paymentRequestResponse.responseJSON : null;

            if (responseJSON) {
                helper.shoppayBtnDisabledStyle(document.getElementById("shop-pay-button-container"));
            }

            if (responseJSON && !responseJSON.error && responseJSON.paymentRequest !== null) {
                session.close();
                session = initShopPaySession();
            }
        }
    }
});


function initShopPaySession(paymentRequestInput, readyToOrder) {
    var paymentRequest;
    var paymentRequestResponse;
    var responseJSON;

    if (isBuyNow && paymentRequestInput) {
        paymentRequest = paymentRequestInput;
    } else if (isBuyNow && !paymentRequestInput) {
        var productData = helper.getInitProductData();
        if (productData) {
            paymentRequestResponse = helper.createResponse(productData, window.shoppayClientRefs.urls.BuyNowData);
            if (paymentRequestResponse.exception || paymentRequestResponse.error){
                /*  No need to close any session because a session does not exist at this point (has not yet been
                    initiated). Return to exit function - don't reload the page in case there is a page rendering
                    issue (will result in infinite reload loop).
                */
                return;
            }
            paymentRequest = paymentRequestResponse.paymentRequest;
            responseJSON = paymentRequestResponse ? paymentRequestResponse : null;
        }
    } else {
        paymentRequestResponse = helper.buildPaymentRequest(session);
        responseJSON = paymentRequestResponse ? paymentRequestResponse.responseJSON : null;
    }

    if (paymentRequest || (responseJSON && !responseJSON.error)) {
        var initialPaymentRequest = responseJSON && responseJSON.paymentRequest ? window.ShopPay.PaymentRequest.build(responseJSON.paymentRequest) : window.ShopPay.PaymentRequest.build(paymentRequest);
        // Enable BuyNow Button Click on PDP if Product is Ready To Order
        helper.shoppayBtnDisabledStyle(document.getElementById("shop-pay-button-container"), readyToOrder);

        var shoppaySession = window.ShopPay.PaymentRequest.createSession({
            paymentRequest: initialPaymentRequest
        });

        if (shoppaySession) {
            helper.setSessionListeners(shoppaySession);
            $('body').off('product:afterAttributeSelect', initBuyNow);

            $('body').on('product:afterAttributeSelect', function(e, response) {
                var responseProduct = response.data.product;
                if (isBuyNow && responseProduct.buyNow) {
                    helper.setInitProductData({
                        pid: responseProduct.id,
                        quantity: responseProduct.selectedQuantity,
                        options: responseProduct.options
                    });
                    if (shoppaySession) {
                        shoppaySession.close();
                        let updatedPaymentRequest = window.ShopPay.PaymentRequest.build(responseProduct.buyNow);
                        shoppaySession = window.ShopPay.PaymentRequest.createSession({
                            paymentRequest: updatedPaymentRequest
                        });

                        helper.setSessionListeners(shoppaySession);
                    }

                } else {
                    $.ajax({
                        url: helper.getUrlWithCsrfToken(window.shoppayClientRefs.urls.GetCartSummary),
                        type: 'GET',
                        contentType: 'application/json',
                        async: false,
                        success: function (data) {
                            if (!data.error) {
                                if (shoppaySession) {
                                    shoppaySession.close();
                                }
                                let paymentRequest = window.ShopPay.PaymentRequest.build(response.product.buyNow);
                                shoppaySession = window.ShopPay.PaymentRequest.createSession({
                                    paymentRequest: paymentRequest
                                });
                                helper.setSessionListeners(shoppaySession);
                            }
                        },
                        error: function (err) {
                            if (err.responseJSON || err.status !== 200) {
                                session.close();
                                // modal hasn't opened yet so "windowclosed" listener won't fire
                                window.location.reload();
                                return;
                            }
                        }
                    });
                }
            });
        }

        return shoppaySession;
    }
}

module.exports = {
    initShopPaySession: initShopPaySession
};